export default "__VITE_ASSET__CMhue2YW__"